export class KrysskampenConstants {
  static readonly NumberOfVisibleQuestionsFromStart = Number.MAX_SAFE_INTEGER;
  static readonly NumberOfVisibleCharsPerQuestion = 7;
  static readonly PlayerCanShowNumberOfChars = 3;
  static readonly CharsAddedPerTurn = 7;
}
